import './CongratulationsPageForGigReg.scss';
import { Button, Typography } from '@mui/material';
import Lottie from 'lottie-react';
import successLottie from '../../../assets/lottie_animations/success-lottie.json';

interface CongratulationsPageForGigRegProps {
    needTopSpace?: boolean;
    title: string;
    description: string;
    buttonText: string;
    buttonIcon: JSX.Element;
    onClickHandler: () => void;
}

const CongratulationsPageForGigReg = ({ title, description, buttonIcon, buttonText, onClickHandler, needTopSpace }: CongratulationsPageForGigRegProps) => {
        
  return (
    <div className='congratulations-page-modal'>
        <div className='main-container-modal'>
            <Lottie className="success-lottie-modal" animationData={successLottie} loop={true}></Lottie>
            <Typography fontSize={40} fontWeight={'bold'} width={"100%"}>
                {title}
            </Typography>

            <Typography fontSize={20} marginTop={'16px'} fontWeight={'regular'} width={"100%"} lineHeight={"1.6rem"}>
                {description}
            </Typography>

            <Button 
            className="action-btn-modal" 
            startIcon={<div className='btn-image-container-modal'>{buttonIcon}</div>} 
            variant='contained' 
            size='large'
            onClick={onClickHandler}>
                {buttonText}
            </Button>
        </div>
    </div>
  )
}

export default CongratulationsPageForGigReg